export const ADMIN_EMAILS = new Set([
  "jeancenteno54@fastadmin.com",
  "jeziel@fastadmin.com",
]);

export const esAdminPrincipal = (
  userEmail: string | null | undefined
): boolean => Boolean(userEmail && ADMIN_EMAILS.has(userEmail));
